import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { gqlConnect } from 'react-connect-graphql-beta'

class DownloadRedirect extends Component {
  componentDidMount() {
    const { data } = this.props.gql
    const { history, match } = this.props

    if (!data) return

    const userAgent = navigator.userAgent
    const isAndroid = /Android/i.test(userAgent)
    const isLegacyApple = /iPad|iPhone|iPod/i.test(userAgent)
    const isModernApple = /Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 0
    const isApple = isLegacyApple || isModernApple

    const appleUrl = `https://apps.apple.com/app/id${data.appleAppId}`
    const googleUrl = `https://play.google.com/store/apps/details?id=${data.googleAppId}`

    if (isAndroid && data.googleAppId) {
      window.location.replace(googleUrl)
    } else if (isApple && data.appleAppId) {
      window.location.replace(appleUrl)
    } else {
      history.replace(`/download/${data.slug}`)
    }
  }

  render() {
    return null
  }
}

export default gqlConnect('download')(withRouter(DownloadRedirect))